module.exports = "pegasus/assets/repeat-large.png";